import Carousel from "./component/Carousel";
import Download from "./component/Download";
import Footer from "./component/Footer";
import Games from "./component/Games";

import "./styles/index.scss";

function App() {
  return (
    <div className="app-container">
      <div className="app-games">
        <Carousel />
        <Games />
      </div>
      <div className="app-content">
        <Download />
      </div>

      <footer className="app-footer">
        <Footer />
      </footer>
    </div>
  );
}

export default App;
